import PropTypes from 'prop-types';
import React from 'react';
import { compose, pure } from 'recompose';
import { Table, Head, Header, Body, withActiveItem } from 'components/list';
import withSpinner from 'components/withSpinner';
import withTutorial from 'components/withTutorial';
import ListItem from './ListItem';
import NoRipMessage from './NoRipMessage';

const DocumentCifList = ({ items, allMode }) => (
    <Table>
        <Head>
            {allMode && <Header sortProperty="user.lastName" text="Conseiller" />}
            <th />
            <Header sortProperty="name" text="Nom du RIP" />
            <Header sortProperty="type" text="Type de demande" />
            <Header sortProperty="requestedAt" text="Date de la demande" />
            <Header sortProperty="status" text="Statut du dossier" />
            {/* <Header sortProperty="" text="Date du statut" /> */}
            <Header sortProperty="caseManager.lastName" text="Suivi par" />
        </Head>
        <Body>
            {items.map((item) => <ListItem key={item.id} item={item} allMode={allMode} />)}
        </Body>
    </Table>
);

export const itemShape = {
    id: PropTypes.string,
    ripId: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
    requestedAt: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
};

DocumentCifList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
    allMode: PropTypes.bool,
};

DocumentCifList.defaultProps = {
    allMode: false,
};

export default compose(
    withSpinner,
    withTutorial(NoRipMessage),
    withActiveItem,
    pure,
)(DocumentCifList);
